import Pagination from '@Components/Common/Pagination';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ColumnType, DynamicTable } from '@Components/General/DynamicTable';
import ItemsPerPage from '@Components/General/ItemsPerPage';
import { useNavigate } from '@tanstack/react-router';
import {
    ContactField,
    AddressField,
    ConnectionField,
    EmailField,
    PhoneField,
} from '@Components/General/DynamicTable/Cells';

const TableHeader = ({ count, pageSize, setPageSize }) => {
    const { t } = useTranslation();
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{`${count.toLocaleString()} ${t(
                'Contacts',
            )}`}</Typography>
            <ItemsPerPage
                label={t('Contacts')}
                pageSize={pageSize}
                onChange={setPageSize}
            />
        </Box>
    );
};

function ContactsTable({
    contacts,
    pageCount,
    page,
    pageSize,
    setPageSize,
    count,
    setPage,
    getSort,
    onSortChange,
    checkedContacts,
    setCheckedContacts,
    toggleCheckItem,
    tableHeader,
    additionalColumns = [],
    noData,
}) {
    const { t } = useTranslation('controls');
    // const location = useLocation();
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (location.hash) {
    //         const element = document.getElementById(location.hash.slice(1));
    //         if (element) {
    //             element.scrollIntoView();
    //         }
    //     }
    // }, [location.hash]);

    const columns: ColumnType[] = [
        {
            name: t('Contact'),
            sortField: 'name',
            field: 'display_name',
            Component: ContactField,
            sx: { pl: 0 },
            maxWidth: 220,
            checkbox: true,
        },
        {
            name: t('Address'),
            sortField: 'address',
            field: 'address',
            Component: AddressField,
        },
        // {
        //     name: t('Relationship'),
        //     sortField: 'relationship',
        //     field: 'relationship',
        //     Component: ConnectionField,
        // },
        {
            name: t('Email'),
            field: 'email_addresses',
            Component: EmailField,
        },
        {
            name: t('Phone'),
            field: 'phone_numbers',
            Component: PhoneField,
        },
        ...additionalColumns,
        // listStatusField && { name: t("Done"), field: "list_status" }
    ];

    return (
        <>
            <DynamicTable
                tableHeader={
                    tableHeader || (
                        <TableHeader
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            count={count}
                        />
                    )
                }
                noData={noData}
                columns={columns}
                rows={contacts || []}
                checkField="contact_id"
                checkedRows={checkedContacts}
                setCheckedRows={setCheckedContacts}
                toggleCheck={toggleCheckItem}
                getSort={getSort}
                onSortChange={onSortChange}
                rowProps={row => ({
                    onClick: () =>
                        navigate({ to: `/contacts/${row.contact_id}/` }),
                    id: row.contact_id,
                })}
            />
            {contacts.length > 0 && (
                <Pagination
                    sx={{ mt: '2rem' }}
                    pageCount={pageCount}
                    page={page}
                    onChange={setPage}
                />
            )}
        </>
    );
}

export default ContactsTable;
